import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProductList from './pages/Product/ProductList';
import CustomerList from './pages/Customer/CustomerList';
import SupplierList from './pages/Supplier/SupplierList';
import SalesOrderList from './pages/SalesOrder/SalesOrderList';
import PurchaseOrderList from './pages/PurchaseOrder/PurchaseOrderList';
import InventoryList from './pages/Inventory/InventoryList';
import WarehouseList from './pages/Warehouse/WarehouseList';
import ReceivableList from './pages/Finance/ReceivableList';
import PayableList from './pages/Finance/PayableList';
import PaymentList from './pages/Finance/PaymentList';
import ReportCenter from './pages/Report/ReportCenter';
import UserList from './pages/System/UserList';
import RoleList from './pages/System/RoleList';
import OperationLogList from './pages/System/OperationLogList';
import './App.css';

// 受保护的路由组件
const ProtectedRoute = ({ children }) => {
  const { token } = useSelector((state) => state.auth);
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/products" element={<ProductList />} />
                  <Route path="/customers" element={<CustomerList />} />
                  <Route path="/suppliers" element={<SupplierList />} />
                  <Route path="/sales-orders" element={<SalesOrderList />} />
                  <Route path="/purchase-orders" element={<PurchaseOrderList />} />
                  <Route path="/inventory" element={<InventoryList />} />
                  <Route path="/warehouses" element={<WarehouseList />} />
                  <Route path="/finance/receivables" element={<ReceivableList />} />
                  <Route path="/finance/payables" element={<PayableList />} />
                  <Route path="/finance/payments" element={<PaymentList />} />
                  <Route path="/reports" element={<ReportCenter />} />
                  <Route path="/system/users" element={<UserList />} />
                  <Route path="/system/roles" element={<RoleList />} />
                  <Route path="/system/logs" element={<OperationLogList />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
